Moderation.Views ||= {}

class Moderation.Views.DashboardView extends Backbone.View
  template: JST['backbone/templates/moderation/dashboard']
  className: 'dashboard'
  id: 'moderation-dashboard'

  events:
    'click .moderate': 'onClickModerate'

  initialize: (@options = {}) ->
    @sessions = @options.sessions
    @stats = @options.stats
    @current_account = @options.current_account
    @totalsShown = false

  render: =>
    @$el.html(@template(@))
    @addAccounts()
    @addStats()
    @interval = setInterval =>
      @updateCounters()
    , @refreshInterval()
    @

  getModeratorName: ->
    Keepcon.currentUser.name

  addAccounts: ->
    @sortSessions()
    accountsWithSessions = _.groupBy(@sessions, 'account_name')
    for name, sessions of accountsWithSessions
      accountSessionsView = new Moderation.Views.AccountSessionsView
        name: name
        sessions: sessions
        current_account: @current_account
      @$el.find('.accounts-with-sessions').append(accountSessionsView.render().$el)

  sortSessions: ->
    @sessions = _.sortBy(@sessions, (session) ->
      session.account_name
    )

  addStats: ->
    @statsView = new Moderation.Views.StatsView stats: @stats
    @listenTo(@statsView, 'totalsShown', ->
      @totalsShown = true
    )
    @listenTo(@statsView, 'totalsHidden', ->
      @totalsShown = false
    )
    @$el.find('.right-pane').append(@statsView.render(@totalsShown).$el)

  updateCounters: ->
    only_dashboard_sessions = _.filter(@sessions, (session) -> session.type != 'review_queue')
    ids = _.pluck(only_dashboard_sessions, 'id')

    $.ajax
      type: 'POST'
      url: '/moderation/dashboard/session/counters'
      data: {ids: ids}
      success: (response) =>
        @doUpdateCounters(response)
      error: (response) ->
        console.log("An unexpected error has occurred while trying to update the session's counters")

  doUpdateCounters: (response) ->
    sessionCounters = response.session_counters
    reviewQueueCounters = response.review_queue_counters
    @sessions = @sessions.map (session) ->
      counters = if session.type == 'review_queue' then reviewQueueCounters else sessionCounters
      session.blocked_count = counters["#{session.id}"].blocked_count
      session.enqueued_count = counters["#{session.id}"].enqueued_count
      session.last_moderation_date = counters["#{session.id}"].last_moderation_date
      session
    clearInterval(@interval)
    scrollTop = @$el.find('.moderation-dashboard.microscroll').scrollTop()
    @render()
    @$el.find('.moderation-dashboard.microscroll').scrollTop(scrollTop)

  refreshInterval: ->
    30000 # milliseconds

  onClickModerate: (evt) ->
    window.document.location = $(evt.currentTarget).data('href')
